module.exports = __webpack_public_path__ + "static/media/blog2.f40a87df.png";